/* Alex web chat (R3 micro-edit 7 / 7b + handover poll). Native-style: closed by
   default, launcher only; opens on tap; X, outside-tap and Escape close. Thin client
   for the verified /chat contract: POST {session_id, message} -> 200 {reply}.
   Rate-limit / LLM-error replies arrive as {reply} and render normally; any
   network/parse failure -> email fallback. session_id = crypto.randomUUID()
   persisted in localStorage.

   HANDOVER: Tomas can take a conversation over from his phone, so his messages
   arrive without the visitor sending anything. GET {ENDPOINT}/messages?session_id=
   &after_id= returns assistant messages newer than the cursor plus a new cursor.
   Polled every 4s while the panel is open and the tab is visible, never while a
   send is mid-flight, never while the panel is closed. POST also returns last_id,
   which advances the cursor past the reply this client already rendered itself,
   so the poll can never print the same message twice. */
(function () {
  var root = document.getElementById('fc-chat');
  if (!root) return;
  var ENDPOINT = root.getAttribute('data-endpoint') || 'https://voice.formachest.com/chat';
  var POLL_URL = ENDPOINT.replace(/\/+$/, '') + '/messages';
  var KEY = 'fc_chat_session';
  var LOG_KEY = 'fc_chat_log';     // client-side mirror of the rendered transcript
  var GREET_KEY = 'fc_chat_greeted'; // holds the session id the opening message was shown for
  var CUR_KEY = 'fc_chat_cursor';  // highest server message id this browser has rendered
  var POLL_MS = 4000;
  var LOG_MAX = 16;                // matches the server's 16 message reload window
  var ERROR_MSG = "Email support@formachest.com and we'll reply within 24 hours.";
  var GREETING = "Hi, I'm Alex, the FormaChest assistant. Ask me anything about sizing, the protocol, or your order. Tomas reads these, so if I cannot answer something I will pass it to him.";

  var bubble = root.querySelector('.fc-chat__bubble');
  var panel = root.querySelector('.fc-chat__panel');
  var closeBtn = root.querySelector('.fc-chat__close');
  var log = root.querySelector('#fc-chat-log');
  var form = root.querySelector('#fc-chat-form');
  var input = root.querySelector('#fc-chat-input');
  var badge = root.querySelector('.fc-chat__badge');
  var unread = 0;
  var sending = false;

  // Notification badge on the launcher: unread count of Alex replies received while the panel is closed.
  function setBadge(n) {
    if (!badge) return;
    if (n > 0) {
      badge.textContent = n > 9 ? '9+' : String(n);
      badge.hidden = false;
      badge.style.animation = 'none';
      void badge.offsetWidth; // reflow so the pop animation replays on each new reply
      badge.style.animation = '';
    } else {
      badge.hidden = true;
      badge.textContent = '';
    }
  }
  function notifyReply() { if (!isOpen()) { unread += 1; setBadge(unread); } }
  var firstReplyDone = false; // gates the longer 20s pause + self-introduction on Alex's first answer

  function sessionId() {
    var id = null;
    try { id = localStorage.getItem(KEY); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'fc-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      try { localStorage.setItem(KEY, id); } catch (e) {}
    }
    return String(id).slice(0, 64);
  }

  // Transcript mirror. The server keeps the authoritative conversation keyed by
  // session_id; this is only a copy of what THIS browser rendered, so the panel can
  // reopen on what the person already said instead of an empty window. It does not
  // travel across devices or browsers.
  function readLog() {
    try {
      var arr = JSON.parse(localStorage.getItem(LOG_KEY) || '[]');
      return Array.isArray(arr) ? arr.slice(-LOG_MAX) : [];
    } catch (e) { return []; }
  }
  function writeLog(entries) {
    try { localStorage.setItem(LOG_KEY, JSON.stringify(entries.slice(-LOG_MAX))); } catch (e) {}
  }

  // Poll cursor. Kept per session id: a new session starts from scratch rather than
  // replaying someone else's transcript.
  function readCursor() {
    try {
      var o = JSON.parse(localStorage.getItem(CUR_KEY) || 'null');
      if (o && o.sid === sessionId() && typeof o.id === 'number') return o.id;
    } catch (e) {}
    return 0;
  }
  function writeCursor(n) {
    try { localStorage.setItem(CUR_KEY, JSON.stringify({ sid: sessionId(), id: n })); } catch (e) {}
  }
  var cursor = 0;
  function applyCursor(n) {
    if (typeof n === 'number' && n > cursor) { cursor = n; writeCursor(cursor); }
  }

  // replay = rendering a stored message, so it is not written back to the mirror.
  // from = 'tomas' when the founder typed it himself, which the visitor should see.
  function addMsg(text, who, replay, from) {
    var el = document.createElement('div');
    el.className = 'fc-chat__msg fc-chat__msg--' + who + (from === 'tomas' ? ' fc-chat__msg--tomas' : '');
    el.textContent = text; // server text is never parsed as HTML
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    if (!replay) {
      var entries = readLog();
      entries.push({ t: text, w: who, s: from === 'tomas' ? 'tomas' : undefined });
      writeLog(entries);
    }
    return el;
  }

  function typing(on) {
    var t = log.querySelector('.fc-chat__typing');
    if (on && !t) {
      t = document.createElement('div');
      t.className = 'fc-chat__msg fc-chat__msg--bot fc-chat__typing';
      t.innerHTML = '<span></span><span></span><span></span>';
      log.appendChild(t);
      log.scrollTop = log.scrollHeight;
    } else if (!on && t) {
      t.remove();
    }
  }

  // Replay the transcript this browser already rendered, so a page load no longer
  // opens to an empty window while the server still holds the conversation.
  var saved = readLog();
  for (var i = 0; i < saved.length; i++) {
    if (saved[i] && typeof saved[i].t === 'string') {
      addMsg(saved[i].t, saved[i].w === 'user' ? 'user' : 'bot', true, saved[i].s);
    }
  }

  // Opening message: appended once per chat session, keyed to the session id, and
  // never sent to the server. On later loads it returns as part of the replay above,
  // not as a fresh append. If localStorage is unavailable the id is new each load, so
  // it degrades to showing once per load rather than not at all.
  var sid = sessionId();
  var greeted = null;
  try { greeted = localStorage.getItem(GREET_KEY); } catch (e) {}
  if (greeted !== sid) {
    addMsg(GREETING, 'bot');
    try { localStorage.setItem(GREET_KEY, sid); } catch (e) {}
  }

  // ---- handover poll ------------------------------------------------------
  // One request in flight at a time, only while the panel is open and the tab is
  // visible, never during a send (the reply is being staged behind the typing
  // indicator and the POST response owns it). A failed poll is silent: the visitor
  // is mid-conversation and a network blip is not their problem.
  var pollTimer = null, polling = false;

  function poll(prime) {
    if (polling || (sending && !prime)) return;
    polling = true;
    var url = POLL_URL + '?session_id=' + encodeURIComponent(sessionId()) + '&after_id=' + cursor;
    fetch(url, { method: 'GET' })
      .then(function (r) { return r.ok ? r.json() : null; })
      ['catch'](function () { return null; })
      .then(function (d) {
        if (d) {
          if (!prime && d.messages && d.messages.length) {
            for (var i = 0; i < d.messages.length; i++) {
              var m = d.messages[i];
              if (!m || typeof m.text !== 'string' || !m.text) continue;
              addMsg(m.text, 'bot', false, m.from);
              notifyReply();
            }
          }
          applyCursor(d.last_id);
        }
        polling = false;
      })
      ['catch'](function () { polling = false; });
  }

  var primed = false;
  function startPoll() {
    if (pollTimer) {
      poll(false);
      return;
    }
    // First poll of the page. If this browser has no cursor but has already replayed
    // a transcript from its own mirror, prime the cursor instead of fetching that
    // history a second time. With no mirror there is nothing to duplicate, so a real
    // poll runs and recovers the conversation.
    if (!primed && !cursor && saved.length) { primed = true; poll(true); }
    else { primed = true; poll(false); }
    pollTimer = setInterval(function () {
      if (document.hidden || !isOpen()) return;
      poll(false);
    }, POLL_MS);
  }
  function stopPoll() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && isOpen()) poll(false);
  });

  // No polling until the panel is opened: a page view by someone who never opens
  // the chat must not cost a request.
  cursor = readCursor();

  function isOpen() { return root.classList.contains('fc-chat--open'); }
  function open() {
    if (isOpen()) return;
    panel.hidden = false;
    root.classList.add('fc-chat--open');
    document.documentElement.classList.add('fc-chat-lock');
    bubble.setAttribute('aria-expanded', 'true');
    unread = 0; setBadge(0); // opening the panel clears the notification badge
    startPoll();
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
  }
  function close() {
    if (!isOpen()) return;
    panel.hidden = true;
    root.classList.remove('fc-chat--open');
    document.documentElement.classList.remove('fc-chat-lock');
    bubble.setAttribute('aria-expanded', 'false');
    stopPoll();
  }

  bubble.addEventListener('click', function (e) { e.stopPropagation(); isOpen() ? close() : open(); });
  closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
  panel.addEventListener('click', function (e) { e.stopPropagation(); });
  document.addEventListener('click', function (e) { if (isOpen() && !root.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  // Each sentence in Alex's reply adds typing time: a short sentence 5s, a longer one 10s.
  var SHORT_SEC = 5;             // typing seconds for a short sentence
  var LONG_SEC = 10;            // a longer sentence jumps to 10s
  var LONG_WORDS = 12;         // a sentence over this many words counts as "longer"
  var FIRST_SILENT_MS = 20000;  // first answer: 20s with NO indicator, added on top
  var LATER_SILENT_MS = 4500;   // later answers: 4-5s pause before the indicator starts

  // Total indicator seconds = sum over sentences (10s if long, else 5s).
  function replySeconds(text) {
    var parts = String(text).replace(/\s+/g, ' ').trim().match(/[^.!?]+[.!?]*/g) || [text];
    var total = 0;
    for (var i = 0; i < parts.length; i++) {
      var words = parts[i].trim().split(/\s+/).filter(Boolean).length;
      total += (words > LONG_WORDS) ? LONG_SEC : SHORT_SEC;
    }
    return total < SHORT_SEC ? SHORT_SEC : total;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    var msg = (input.value || '').trim().slice(0, 1000);
    if (!msg) return;
    addMsg(msg, 'user');
    input.value = '';
    sending = true;

    var first = !firstReplyDone;
    var silentGap = first ? FIRST_SILENT_MS : LATER_SILENT_MS;
    // Started now, in parallel with the fetch, so the wait is time well spent rather
    // than stacked on top of the network round trip.
    var gapP = wait(silentGap);

    var replyP = fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId(), message: msg })
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      ['catch'](function () { return null; });

    replyP
      .then(function (data) {
        if (data) applyCursor(data.last_id);
        // Tomas has this conversation. Alex says nothing, the visitor's message is
        // already on his phone, and his answer arrives through the poll. The typing
        // theatre is skipped: nobody is typing on this side.
        if (data && data.handover) {
          firstReplyDone = true;
          sending = false;
          startPoll();
          return null;
        }
        var reply = (data && typeof data.reply === 'string' && data.reply.length) ? data.reply : ERROR_MSG;
        // 1) silent gap, NO indicator.  2) indicator shows for 5s per short sentence,
        // 10s per long one.  3) the whole reply is published at once.
        return gapP
          .then(function () {
            typing(true);
            return wait(replySeconds(reply) * 1000);
          })
          .then(function () { return reply; });
      })
      .then(function (reply) {
        if (reply === null || reply === undefined) return;
        typing(false);
        addMsg(reply, 'bot');
        notifyReply();
        firstReplyDone = true;
        sending = false;
      })
      ['catch'](function () {
        typing(false);
        addMsg(ERROR_MSG, 'bot');
        notifyReply();
        firstReplyDone = true;
        sending = false;
      });
  });
})();

